import { Tag } from 'antd';

const defCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State defOption: Options = new Options({
    title: {
      show: true,
      text: '基础属性',
      left: 40,
      top: 20
    },
    series:[
      {
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`
const changeCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State defOption: Options = new Options({
    title: {
      show: true,
      text: '基础属性',
      left: 40,
      top: 20
    },
    series:[
      {
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:548, name:'鸿蒙'}
        ]
      }
    ]
  })
  aboutToAppear() {
    setTimeout(() => {
      // 使用Option实例对象的setVal方法来实现，修改什么属性就传什么
      this.defOption.setVal({
        series: [
          {
            data:[
              {value:435, name:'IOS'},
              {value:310, name:'安卓'},
              {value:234, name:'我心澎湃'},
              {value:135, name:'蓝河'},
              {value:1548, name:'鸿蒙'}
            ]
          }
        ]
      })
    }, 2000)
  }
  build() {
    Row() {
      McPieChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`
const legendCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State legendOption: Options = new Options({
    title: {
      show: true,
      text: 'legend属性',
      left: 40,
      top: 20
    },
    legend: {
      show: true,
      left: '10%',
      top: '40%',
      orient: 'vertical',
      itemGap: 10,
      itemTextGap: 10,
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        color: '#000',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 24
      }
    },
    series:[
      {
        center: ['70%', '50%'], // 饼图中心位置
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const titleCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State titleOption: Options = new Options({
    title: {
      show: true,
      text: '操作系统分布', // 主标题文本
      subtext: '占比', // 副标题文本
    },
    series:[
      {
        radius: ['75%', '60%'], // 饼图外半径
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const tooltipCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
      title: {
          show: true,
          text: 'tooltip属性',
          left: 40,
          top: 20
      },
      tooltip: {
        borderColor: '#f72659f5',
        borderWidth: 1,
        backgroundColor: '#fff',
        textStyle: { // 文本样式配置
          color: '#000'
        }
      },
      series:[
        {
          data:[
              {value:435, name:'IOS'},
              {value:310, name:'安卓'},
              {value:234, name:'我心澎湃'},
              {value:135, name:'蓝河'},
              {value:1548, name:'鸿蒙'}
          ]
        }
      ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.tooltipOption
      })
    }
    .height('50%')
  }
}
`

const cTooltipCode = `
import { McPieChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
      title: {
          show: true,
          text: '自定义tooltip属性',
          left: 40,
          top: 20
      },
      series:[
        {
          data:[
              {value:435, name:'IOS'},
              {value:310, name:'安卓'},
              {value:234, name:'我心澎湃'},
              {value:135, name:'蓝河'},
              {value:1548, name:'鸿蒙'}
          ]
        }
      ]
  })
  @Builder
  customTooltip($$: chartInterface.InterfaceObj) {
    if ($$.tooltipInfo.title) {
      Text($$.tooltipInfo.title)
    }
    ForEach($$.tooltipInfo.data, (item: chartInterface.InterfaceObj, index) => {
      Text(item.name + '：' + item.num)
    })
  };
  build() {
    Row() {
      McPieChart({
        options: this.tooltipOption,
        customTooltip: this.customTooltip
      })
    }
    .height('50%')
  }
}
`

const seriesCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State seriesOption: Options = new Options({
    title: {
      show: true,
      text: 'series属性',
      left: 40,
      top: 20
    },
    series:[
      {
        radius: '75%', // 饼图外半径
        label: {
          show: true,
          fontSize: 40,
          shadowBlur: 20,
          shadowColor: '#ffababab',
          shadowOffsetX: 2,
          shadowOffsetY: 4,
          formatter: (params: chartInterface.InterfaceObj, index: number) => {
            return params.percentForLabel + '%'
          }
        },
        labelLine: { // 文本连接线的配置
          show: false
        },
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.seriesOption
      })
    }
    .height('50%')
  }
}
`

const roseTypeOption = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State roseTypeOption: Options = new Options({
    title: {
      show: true,
      text: '玫瑰饼状图',
      left: 40,
      top: 20
    },
    series:[
      {
        roseType: true,
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.roseTypeOption
      })
    }
    .height('50%')
  }
}
`

const moreOption = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State moreOption: Options = new Options({
    title: {
      show: true,
      text: '多组状图',
      left: 40,
      top: 20
    },
    legend: {
      show: false
    },
    series:[
      {
        name: '占比',
        radius: '30%',
        labelLine: { // 文本连接线的配置
          show: false
        },
        label: {
          show: true
        },
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      },
      {
        name: '环比',
        radius: ['40%', '50%'],
        data:[
          {value:435, name:'IOS'},
          {value:310, name:'安卓'},
          {value:234, name:'我心澎湃'},
          {value:135, name:'蓝河'},
          {value:1548, name:'鸿蒙'}
        ]
      }
    ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.moreOption
      })
    }
    .height('50%')
  }
}
`


const annularSeriesCode = `
import { McPieChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State seriesOption: Options = new Options({
      series:[
        {
          radius: ['80%', '50%'], // 饼图外半径、内半径
          center: ['50%', '50%'], // 饼图中心位置
          data:[
            {value:435, name:'直接访问'},
            {value:310, name:'邮件营销'},
            {value:234, name:'联盟广告'},
            {value:135, name:'视频广告'},
            {value:1548, name:'搜索引擎'}
          ]
        }
      ]
  })
  build() {
    Row() {
      McPieChart({
        options: this.seriesOption
      })
    }
    .height('50%')
  }
}
`


const columns = [
    {
        title: '名称',
        width: 200,
        dataIndex: 'name',
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color="#2db7f5">{!text ? '否' : '是'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];

const commonData = [
  {
    name: 'grid',
    describe: '直角坐标系内绘图网格',
    type: 'Object',
    defVal: '{}',
    state: '',
    remarks: '用于设置上下左右四个边距，替代历史的cPaddingL、cPaddingT、cPaddingR、cPaddingB四个属性，不过最新版本也会兼容旧的使用方式',
    children: [
        {
            name: 'left',
            describe: '图表内容区距离左侧位置',
            type: 'String | Number',
            defVal: '10%',
            remarks: '',
        },
        {
            name: 'right',
            describe: '图表内容区距离右侧位置',
            type: 'String | Number',
            defVal: '8%',
            remarks: '',
        },
        {
            name: 'top',
            describe: '图表内容区距离顶部位置',
            type: 'String | Number',
            defVal: '40',
            remarks: '',
        },
        {
            name: 'bottom',
            describe: '图表内容区距离底部位置',
            type: 'String | Number',
            defVal: '30',
            remarks: '',
        }
    ]
},
    {
        name: 'color',
        describe: '调色盘颜色列表',
        type: 'String[]',
        defVal: "['#296DFF', '#ff5495fd', '#ff1acffd', '#ff72e4fd', '#7B72F7', '#F85758', '#FFBF29', '#D1E9F9', '#F5FAFC', '#5A657A']",
        remarks: '',
    },
    {
        name: 'title',
        describe: '标题组件与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看title属性讲解',
    },
    {
        name: 'legend',
        describe: '图例样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看legend属性讲解',
    },
    {
        name: 'tooltip',
        describe: '提示层样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看tooltip属性讲解',
    },
    {
        name: 'animation',
        describe: '是否开启动画。',
        type: 'Boolean',
        defVal: "true",
        state: '',
        remarks: '如果频繁更新数据建议将该属性设置为false',
    },
    {
        name: 'series',
        describe: '饼状区域样式与功能配置',
        type: 'Object[]',
        defVal: "[ ... ]",
        must: true,
        remarks: '详细默认值请查看series属性讲解',
    }
];

const legendData = [
  {
      name: 'show',
      describe: '控制图例显示与隐藏',
      type: 'Boolean',
      defVal: 'true',
      remarks: '可选值：true(显示)、false(隐藏)',
  },
  {
      name: 'orient',
      describe: '图例的方向',
      type: 'String',
      defVal: "'horizontal'",
      state: '',
      remarks: '可以设置为 "horizontal" 或 "vertical"，分别表示水平和垂直方向。'
  },
  {
      name: 'left',
      describe: '图例距离左侧位置',
      type: 'String|Number',
      defVal: 'auto',
      remarks: '',
  },
  {
      name: 'top',
      describe: '图例距离顶部位置',
      type: 'String|Number',
      defVal: '6%',
      remarks: '',
  },
  {
      name: 'right',
      describe: '图例距离右侧位置',
      type: 'String|Number',
      defVal: 'auto',
      state: '',
      remarks: '',
  },
  {
      name: 'bottom',
      describe: '图例距离底部位置',
      type: 'String|Number',
      defVal: 'auto',
      state: '',
      remarks: '',
  },
  {
      name: 'icon',
      describe: '图例项的icon',
      type: 'String',
      defVal: "'roundRect'",
      state: '',
      remarks: '可以设置为 "rect"、"circle" 或 "roundRect"，分别表示矩形、圆形和圆角矩形。'
  },
  {
      name: 'iconRadian',
      describe: '图例项的icon的圆角，只针对icon为roundRect',
      type: 'Number',
      defVal: '2',
      state: '',
      remarks: '当icon设置为 "roundRect" 时，此属性用于设置圆角的半径。'
  },
  {
      name: 'itemGap',
      describe: '每项图例之间的间隔',
      type: 'Number',
      defVal: '10',
      remarks: '',
  },
  {
      name: 'itemTextGap',
      describe: '图形与文本的距离',
      type: 'Number',
      defVal: "5",
      remarks: '',
  },
  {
      name: 'itemWidth',
      describe: '图形的宽度',
      type: 'Number',
      defVal: "16",
      remarks: '',
  },
  {
      name: 'itemHeight',
      describe: '图形的高度',
      type: 'Number',
      defVal: "8",
      remarks: '',
  },
  {
      name: 'align',
      describe: '图例标记和文本的对齐。纵向布局的图例标记和文本的对齐。默认自动，根据组件的位置和 orient 决定，当组件的 left 值为 \'right\' 以及纵向布局（orient 为 \'vertical\'）的时候为右对齐，即为 \'right\'',
      type: 'String',
      defVal: "'auto'",
      state: '',
      remarks: '可以设置为 "left" 或 "right"，分别表示左对齐和右对齐。'
  },
  {
      name: 'selectAble',
      describe: '图例项是否可选',
      type: 'Boolean',
      defVal: 'true',
      state: '',
      remarks: '设置为 true 时，用户可以通过点击图例项来选择或取消选择相应的数据系列。'
  },
  {
      key: 52,
      name: 'textUnselectedStyle',
      describe: '图例未选中状态的文字默认样式配置',
      type: 'Object',
      defVal: "{ ... }",
      state: '',
      remarks: '用于设置图例未选中状态下文字的样式，如颜色、字体大小等。',
      children: [
          {
              key: 521,
              name: 'fontFamily',
              describe: '字体样式',
              type: 'String',
              defVal: "sans-serif",
              remarks: ''
          },
          {
              key: 522,
              name: 'fontSize',
              describe: '字体大小',
              type: 'Number',
              defVal: "30",
              remarks: ''
          },
          {
              key: 523,
              name: 'color',
              describe: '字体颜色',
              type: 'String',
              defVal: "#999",
              remarks: '支持RGB、RGBA、十六进制格式'
          }
      ]
  },
  {
      key: 53,
      name: 'iconUnselectedStyle',
      describe: '图例未选中状态的图标默认样式配置',
      type: 'Object',
      defVal: "{ ... }",
      state: '',
      remarks: '用于设置图例未选中状态下图标的颜色样式。',
      children: [
          {
              key: 531,
              name: 'color',
              describe: '图标颜色',
              type: 'String',
              defVal: "#999",
              remarks: '支持RGB、RGBA、十六进制格式'
          }
      ]
  },
  {
      name: 'textStyle',
      describe: '文本样式配置',
      type: 'Object',
      defVal: "{ ... }",
      remarks: '',
      children: [
          {
              name: 'color',
              describe: '字体颜色',
              type: 'String',
              defVal: "#333",
              remarks: '支持RGB、RGBA、十六进制格式',
          },
          {
              name: 'fontSize',
              describe: '字体大小',
              type: 'Number',
              defVal: "30",
              remarks: '',
          },
          {
              name: 'fontWeight',
              describe: '字体粗细',
              type: 'String',
              defVal: "normal",
              remarks: '',
          },
          {
              name: 'fontFamily',
              describe: '字体样式',
              type: 'String',
              defVal: "sans-serif",
              remarks: '',
          }
      ]
  }
];

const tooltipData = [
    {
        name: 'show',
        describe: '控制提示层显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'type',
        describe: '提示层显示类型',
        type: 'String',
        defVal: 'default',
        remarks: '可选值：default（默认）、custom（自定义）。需要注意是自定义需要配合监控点击方法回调，通过回调信息自行显示内容与位置',
    },
    {
        name: 'backgroundColor',
        describe: '提示框背景颜色',
        type: 'String',
        defVal: 'rgba(50,50,50,0.7)',
        remarks: '',
    },
    {
        name: 'borderColor',
        describe: '提示框边框颜色',
        type: 'String',
        defVal: "#333",
        remarks: '',
    },
    {
        name: 'borderWidth',
        describe: '提示框边框宽度',
        type: 'Number',
        defVal: "0",
        remarks: '',
    },
    {
        name: 'padding',
        describe: '提示框内边距',
        type: 'Number',
        defVal: "10",
        remarks: '',
    },
    {
        key: 2,
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 21,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 22,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 23,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 25,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const titleData = [
  {
      name: 'show',
      describe: '控制标题显示与隐藏',
      type: 'Boolean',
      defVal: 'true',
      remarks: '可选值：true(显示)、false(隐藏)',
  },
  {
      name: 'text',
      describe: '主标题文本，支持使用 \n 换行。',
      type: 'String',
      defVal: '',
      remarks: '',
  },
  {
      name: 'subtext',
      describe: '副标题文本，支持使用 \n 换行。',
      type: 'String',
      defVal: '',
      remarks: '',
  },
  {
      name: 'itemGap',
      describe: '主副标题之间的间距。',
      type: 'Number',
      defVal: "5",
      remarks: '',
  },
  {
      key: 69,
      name: 'left',
      describe: '标题左侧位置',
      type: 'String | Number',
      defVal: "'auto'",
      state: '',
      remarks: '可以设置为 "auto"、百分比或具体数值。'
  },
  {
    key: 70,
    name: 'right',
    describe: '标题右侧位置',
    type: 'String | Number',
    defVal: "'auto'",
    state: '',
    remarks: '可以设置为 "auto"、百分比或具体数值。'
  },
  {
    key: 71,
    name: 'top',
    describe: '标题顶部位置',
    type: 'String | Number',
    defVal: "'auto'",
    state: '',
    remarks: '可以设置为 "auto"、百分比或具体数值。'
  },
  {
    key: 72,
    name: 'bottom',
    describe: '标题底部位置',
    type: 'String | Number',
    defVal: "'auto'",
    state: '',
    remarks: '可以设置为 "auto"、百分比或具体数值。'
  },
  {
    key: 73,
    name: 'offset',
    describe: '标题偏移量',
    type: 'Array',
    defVal: '[0, -20]',
    state: '',
    remarks: '用于设置标题相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
  },
  {
      key: 2,
      name: 'textStyle',
      describe: '文本样式配置',
      type: 'Object',
      defVal: "{ ... }",
      remarks: '',
      children: [
          {
              key: 21,
              name: 'color',
              describe: '字体颜色',
              type: 'String',
              defVal: "#333",
              remarks: '支持RGB、RGBA、十六进制格式',
          },
          {
              key: 22,
              name: 'fontSize',
              describe: '字体大小',
              type: 'Number',
              defVal: "18",
              remarks: '',
          },
          {
              key: 23,
              name: 'fontWeight',
              describe: '字体粗细',
              type: 'String',
              defVal: "normal",
              remarks: '',
          },
          {
              key: 25,
              name: 'fontFamily',
              describe: '字体样式',
              type: 'String',
              defVal: "sans-serif",
              remarks: '',
          },
          {
              key: 74,
              name: 'textAlign',
              describe: '文本对齐方式',
              type: 'String',
              defVal: "'center'",
              state: '',
              remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
          },
          {
              key: 75,
              name: 'textBaseline',
              describe: '文本基线对齐方式',
              type: 'String',
              defVal: "'bottom'",
              state: '',
              remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
          }
      ]
  },
  {
      key: 3,
      name: 'subtextStyle',
      describe: '文本样式配置',
      type: 'Object',
      defVal: "{ ... }",
      remarks: '',
      children: [
          {
              key: 31,
              name: 'color',
              describe: '字体颜色',
              type: 'String',
              defVal: "#aaa",
              remarks: '支持RGB、RGBA、十六进制格式',
          },
          {
              key: 32,
              name: 'fontSize',
              describe: '字体大小',
              type: 'Number',
              defVal: "12",
              remarks: '',
          },
          {
              key: 33,
              name: 'fontWeight',
              describe: '字体粗细',
              type: 'String',
              defVal: "normal",
              remarks: '',
          },
          {
              key: 35,
              name: 'fontFamily',
              describe: '字体样式',
              type: 'String',
              defVal: "sans-serif",
              remarks: '',
          },
          {
            key: 76,
            name: 'textAlign',
            describe: '文本对齐方式',
            type: 'String',
            defVal: "'center'",
            state: '',
            remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
        },
        {
            key: 77,
            name: 'textBaseline',
            describe: '文本基线对齐方式',
            type: 'String',
            defVal: "'bottom'",
            state: '',
            remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
        }
      ]
  }
];

const seriesData = [
    {
        name: 'name',
        describe: '系列名称',
        type: 'String',
        defVal: "空",
        remarks: '',
        must: true,
    },
    {
        name: 'color',
        describe: '系列颜色',
        type: 'String',
        defVal: "空",
        state: 'del',
        remarks: '已弃用',
    },
    {
        name: 'radius',
        describe: '饼图内半径与外半径',
        type: 'String|Number|Array',
        defVal: "'50%'",
        remarks: '半径支持传两个数值（最多两个），一个表示全圆，两个表示外半径与内半径，从而形成环形。',
    },
    {
        name: 'center',
        describe: '饼图的中心位置',
        type: 'String[]',
        defVal: "['50%', '50%']",
        remarks: '只支持百分比格式',
    },
    {
      key: 76,
      name: 'roseType',
      describe: '是否启用玫瑰型',
      type: 'Boolean',
      defVal: 'false',
      state: '',
      remarks: '设置为 true 时，启用玫瑰型图表。'
    },
    {
      key: 77,
      name: 'roseSort',
      describe: '玫瑰型自动排序',
      type: 'Boolean',
      defVal: 'true',
      state: '',
      remarks: '设置为 true 时，启用玫瑰型图表的自动排序。'
    },
    {
      key: 78,
      name: 'roseIncrement',
      describe: '玫瑰型半径增加量',
      type: 'String | Number',
      defVal: "'auto'",
      state: '',
      remarks: '可以设置为 "auto"、百分比或具体数值。'
    },
    {
        key: 82,
        name: 'labelLine',
        describe: '饼图外部标签配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '用于配置饼图外部标签的显示、格式化、样式以及连线样式。',
        children: [
            {
                key: 821,
                name: 'show',
                describe: '是否显示外部标签',
                type: 'Boolean',
                defVal: 'true',
                remarks: '设置为 true 时，显示外部标签。'
            },
            {
                key: 822,
                name: 'formatter',
                describe: '标签格式化',
                type: 'String | Function',
                defVal: "'{name}'",
                remarks: '支持字符串模板和回调函数。例如，可以设置为 "{name}"、"${name}-{value}-{percent}%" 或 (dataItem, index) => (dataItem.name)。'
            },
            {
                key: 823,
                name: 'style',
                describe: '标签默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '用于配置外部标签的默认样式，包括字体大小、阴影等。',
                children: [
                    {
                        key: 8231,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: '22',
                        remarks: ''
                    },
                    {
                        key: 8232,
                        name: 'shadowColor',
                        describe: '轴标签阴影',
                        type: 'String',
                        defVal: "'rgba(0, 0, 0, 0)'",
                        remarks: '支持RGB、RGBA、十六进制格式。'
                    },
                    {
                        key: 8233,
                        name: 'shadowBlur',
                        describe: '轴标签阴影大小',
                        type: 'Number',
                        defVal: '0',
                        remarks: ''
                    },
                    {
                        key: 8234,
                        name: 'shadowOffsetX',
                        describe: '轴标签阴影X轴方向的偏移',
                        type: 'Number',
                        defVal: '0',
                        remarks: ''
                    },
                    {
                        key: 8235,
                        name: 'shadowOffsetY',
                        describe: '轴标签阴影Y轴方向的偏移',
                        type: 'Number',
                        defVal: '0',
                        remarks: ''
                    }
                ]
            },
            {
                key: 824,
                name: 'length',
                describe: '标签连线弯曲处与饼图的距离',
                type: 'String | Number',
                defVal: "'20%'",
                remarks: '可以设置为百分比或具体数值。'
            },
            {
                key: 825,
                name: 'length2',
                describe: '标签连线末端长度',
                type: 'Number',
                defVal: '20',
                remarks: ''
            },
            {
                key: 826,
                name: 'lineStyle',
                describe: '标签连线默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '用于配置标签连线的默认样式，包括宽度和颜色。',
                children: [
                    {
                        key: 8261,
                        name: 'width',
                        describe: '宽度',
                        type: 'Number',
                        defVal: '1',
                        remarks: ''
                    },
                    {
                        key: 8262,
                        name: 'color',
                        describe: '颜色',
                        type: 'String',
                        defVal: "''",
                        remarks: '支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    },
    {
        key: 3,
        name: 'label',
        describe: '系列文本标签样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 30,
                name: 'show',
                describe: '是否显示文本标签',
                type: 'Boolean',
                defVal: "false",
                remarks: '可选值：true（是）、false（否）',
            },
            {
                key: 31,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 32,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 33,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 35,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            },
            {
                key: 38,
                name: 'position',
                describe: '文本显示位置',
                type: 'String',
                defVal: "outside",
                state: 'del',
                remarks: '可选值：center（居中）、outside（外部）',
            },
            {
                key: 36,
                name: 'distanceToLabelLine',
                describe: '字体与饼状间距',
                type: 'Number',
                defVal: "5",
                state: 'del',
                remarks: '',
            },
            {
                key: 37,
                name: 'formatter',
                describe: '标签格式化',
                type: 'String | Function',
                defVal: "'{value}'",
                state: '',
                remarks: '支持字符串模板和回调函数。例如，可以设置为 "{percent}%"、"${name}-{value}-{percent}%" 或 (dataItem, index) => (dataItem.name)。'
            },
            {
                key: 80,
                name: 'textAlign',
                describe: '标签字体水平对齐',
                type: 'String',
                defVal: "'center'",
                state: '',
                remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
            },
            {
                key: 81,
                name: 'textBaseline',
                describe: '标签字体垂直对齐',
                type: 'String',
                defVal: "'middle'",
                state: '',
                remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
            },
            {
                key: 38,
                name: "shadowColor",
                describe: "轴标签阴影颜色",
                type: "String",
                defVal: "'rgba(0, 0, 0, 0)'",
                state: "new",
                remarks: "使用rgba格式指定颜色及透明度，默认为完全透明。"
            },
            {
                key: 39,
                name: "shadowBlur",
                describe: "轴标签阴影大小",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "控制阴影的模糊程度，值越大，阴影边缘越模糊。"
            },
            {
                key: 391,
                name: "shadowOffsetX",
                describe: "轴标签阴影X轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向右偏移，负值表示向左偏移。"
            },
            {
                key: 392,
                name: "shadowOffsetY",
                describe: "轴标签阴影Y轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向下偏移，负值表示向上偏移。"
            }
        ]
    },
    {
        key: 5,
        name: 'emphasis',
        describe: '饼图高亮样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        state: 'del',
        children: [
            {
                key: 50,
                name: 'scale',
                describe: '是否缩放',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true（是）、false（否）',
            },
            {
                key: 51,
                name: 'scaleSize',
                describe: '缩放大小',
                type: 'Number',
                defVal: "4",
                remarks: '',
            },
            {
                key: 52,
                name: 'shadowColor',
                describe: '高亮阴影颜色',
                type: 'String',
                defVal: "rgba(0, 0, 0, 0.5)",
                remarks: '',
            },
            {
                key: 53,
                name: 'shadowBlur',
                describe: '高亮阴影大小',
                type: 'Number',
                defVal: "15",
                remarks: '',
            },
            {
                key: 54,
                name: 'shadowOffsetX',
                describe: '高亮阴影X轴方向的偏移',
                type: 'Number',
                defVal: "0",
                remarks: '',
            },
            {
                key: 55,
                name: 'shadowOffsetY',
                describe: '高亮阴影Y轴方向的偏移',
                type: 'Number',
                defVal: "0",
                remarks: '',
            }
        ]
    },
    {
        key: 83,
        name: 'percentToFixed',
        describe: '百分比小数精度',
        type: 'Number',
        defVal: '0',
        state: '',
        remarks: '设置百分比的小数点后保留位数。'
    },
    {
        name: 'data',
        describe: '系列数据',
        type: '<Object>[]',
        defVal: '[]',
        must: true,
        remarks: '',
        key: 6,
        children: [
            {
                key: 60,
                name: 'value',
                describe: '区域数据',
                type: 'String|Number',
                defVal: "空",
                remarks: '',
                must: true
            },
            {
                key: 61,
                name: 'name',
                describe: '区域名称',
                type: 'String',
                defVal: "空",
                remarks: '',
                must: true
            }
        ]
    }
];

const anchorItems = [
  {
      key: '1',
      href: '#title',
      title: 'title属性',
  },
  {
      key: '3',
      href: '#legend',
      title: 'legend属性'
  },
  {
      key: '4',
      href: '#tooltip',
      title: 'tooltip属性'
  },
  {
      key: '6',
      href: '#series',
      title: 'series属性'
  },
  {
      key: '7',
      href: '#roseTypeOption',
      title: '玫瑰图'
  },
  {
      key: '8',
      href: '#moreOption',
      title: '多组图表'
  },
  {
      key: '9',
      href: '#annularSeriesCode',
      title: '环形饼图'
  }
]


export {
    defCode,
    changeCode,
    legendCode,
    titleCode,
    tooltipCode,
    cTooltipCode,
    seriesCode,
    annularSeriesCode,
    columns,
    commonData,
    titleData,
    legendData,
    tooltipData,
    seriesData,
    roseTypeOption,
    moreOption,
    anchorItems
}
